import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import SelectOTPMethod from './SelectOTPMethod';
import OTPInputBox from './OTPInputBox';
import ChangePasswordBox from './ChangePasswordBox';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ThankYou from './ThankYou';

const ForgotPassword = () => {
    const [step, setStep] = useState(0);
    const [bname, setBname] = useState('Forgot Password');
    const navigate = useNavigate()

    const handleStep = (nextStep, btnname) => {
        if (btnname) setBname(btnname)
        setStep(nextStep);
    };

    const handleGoBack = () => {
        navigate(-1)
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 'calc(100vh-128px)',
                backgroundColor: '#f0f0f0',
                padding: 2
            }}
        >
            <Box
                sx={{
                    width: '45vw',
                    backgroundColor: '#fff',
                    padding: 4,
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    minHeight: "60vh",
                    textAlign: 'center'
                }}
            >
                {/* Render only when on step 0 */}
                {step === 0 && (
                    <>
                        <SelectOTPMethod onBack={handleGoBack} onNext={() => handleStep(3)} buttonName={bname} />
                    </>
                )}
                {console.log(bname, "bname")}
                {/* Conditionally render other components based on step */}
                {step === 3 && <ChangePasswordBox onBack={() => handleStep(0)} onNext={() => handleStep(4)} buttonName={bname} />}
                {step === 4 && <OTPInputBox onBack={() => handleStep(3)} onNext={() => handleStep(5)} buttonName={bname} />}
                {step === 5 && <ThankYou buttonName={bname} />}
            </Box>
        </Box>
    );
};

export default ForgotPassword;
